export enum RugbyUnionScrumAttribute {
  Won = 2982,
  Lost = 2983,
}
